import { useEffect, useState } from 'react';
import { OfferStatus } from 'variables/status';

const statusStyle: Record<string, string> = {
    'not-paid': 'bg-red-50 text-red-500',
    waiting_payment: 'bg-red-50 text-red-500',
    waiting_subscription: 'bg-leadrs-yellow-soft text-leadrs-yellow-focus',
    on_market: 'bg-leadrs-yellow-soft text-leadrs-yellow-focus',
    running: 'bg-leadrs-green-soft text-leadrs-green-focus',
    locked: 'bg-leadrs-purple-soft text-leadrs-purple-focus',
    done: 'bg-leadrs-stroke text-leadrs-text-soft',
};

const BuyerMyOfferCard = (props: {
    bidders: string[];
    industry: string;
    subIndustry: string;
    otherIndustry?: string;
    image: string;
    weeklyQuantity: number;
    extra?: string;
    status: string;
    targetPrice?: string | number;
    onClick?: any;
    leadsGenerated?: number;
    offerNumber?: string;
    user?: any;
    channels: any;
    isGuest?: boolean;
    onGuestClick?: () => void;
    createdAt?: string;
}) => {
    const {
        industry,
        subIndustry,
        otherIndustry,
        weeklyQuantity,
        status,
        image,
        extra,
        onClick,
        user,
        offerNumber,
        targetPrice,
        leadsGenerated,
        channels,
        isGuest = false,
        createdAt,
    } = props;
    const [offerPercentage, setOfferPercentage] = useState(0);

    useEffect(() => {
        if (weeklyQuantity > 0) {
            setOfferPercentage((leadsGenerated / weeklyQuantity) * 100);
        }
    }, [leadsGenerated, weeklyQuantity]);

    // Offre locked = offre du waterfall Batiweb, sans objectif de volume : pas de « x/0 ».
    const isPremium = status === 'locked';
    const statusLabel =
        status === 'not-paid'
            ? 'Non payé'
            : isPremium
              ? 'Offre Premium'
              : OfferStatus[status as keyof typeof OfferStatus] ?? status;

    const statusClass = statusStyle[status] ?? 'bg-leadrs-stroke text-leadrs-text-soft';

    return (
        <div
            className={`flex flex-col w-full bg-white border border-leadrs-stroke rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-200 ${extra}`}
            onClick={onClick}
        >
            <img src={image} className="w-full h-[155px] object-cover" alt="" />

            <div className="p-4 flex flex-col gap-2.5">
                <div className="flex items-start justify-between gap-2">
                    <div>
                        <p className="text-xs font-geist text-leadrs-text-soft">
                            {otherIndustry || subIndustry}
                        </p>
                        <p className="font-crimson text-[22px] font-semibold text-leadrs-text leading-tight">
                            {industry}
                        </p>
                    </div>
                    {offerNumber && (
                        <span className="flex-shrink-0 text-xs font-geist text-leadrs-text-soft">
                            #{offerNumber}
                        </span>
                    )}
                </div>

                <p className="text-sm font-geist text-leadrs-text-soft">
                    Prix : {isGuest ? '···' : `${targetPrice ?? 0}€/lead`}
                </p>

                {createdAt && (
                    <p className="text-xs font-geist text-leadrs-text-soft">
                        Créée le {new Date(createdAt).toLocaleDateString('fr-FR')}
                    </p>
                )}

                <span className={`w-fit rounded-full px-3 py-1 text-xs font-medium font-geist ${statusClass} ${status === 'not-paid' ? 'animate-pulse' : ''}`}>
                    {user && !user.isValidated ? 'En attente de validation' : statusLabel}
                </span>

                <div>
                    <div className="flex justify-between mb-1.5">
                        <span className="text-xs font-geist text-leadrs-text-soft">Leads reçus</span>
                        <span className="text-xs font-geist font-medium text-leadrs-text">
                            {isPremium || !weeklyQuantity ? leadsGenerated || 0 : `${leadsGenerated || 0}/${weeklyQuantity}`}
                        </span>
                    </div>
                    {!isPremium && (
                        <div className="w-full rounded-full bg-leadrs-stroke h-2">
                            <div
                                className="h-2 rounded-full bg-leadrs-brand transition-all"
                                style={{ width: `${Math.min(offerPercentage || 0, 100)}%` }}
                            />
                        </div>
                    )}
                </div>

                <div className="flex flex-wrap gap-1">
                    {channels?.length > 5 ? (
                        <span className="border border-leadrs-stroke rounded px-2 py-0.5 text-xs font-geist text-leadrs-text">
                            {channels.length} canaux d'acquisition
                        </span>
                    ) : (
                        channels?.map((channel: string) => (
                            <span
                                key={channel}
                                className="border border-leadrs-stroke rounded px-2 py-0.5 text-xs font-geist text-leadrs-text"
                            >
                                {channel}
                            </span>
                        ))
                    )}
                </div>

                {status === 'running' && (
                    <p className="text-xs font-geist text-leadrs-text-soft">
                        Délai de livraison : jusqu'à 2 semaines après réception du paiement.
                    </p>
                )}
            </div>
        </div>
    );
};

export default BuyerMyOfferCard;
